import { ApplyContext } from '@kanda-libs/ks-apply';
import { FunctionComponent } from 'react';
import useApplyProvider from './useApplyProvider';

export interface ApplyProviderProps {
  children: JSX.Element;
}

const ApplyProvider: FunctionComponent<ApplyProviderProps> = function ({
  children,
}) {
  const { value, job } = useApplyProvider();

  if (!job) return <></>;

  return (
    <ApplyContext.Provider value={value}>{children}</ApplyContext.Provider>
  );
};

export default ApplyProvider;
